<template>
    <div class="inner-wrapper">
        <!--<div class="page-title" style="width:100%">
            <div class="title-right float-right">
                <div class="btnrow float-right">
                    <a href="javascript:void(0)" data-toggle="modal" data-target="#addTaskModal" class="btn create-btn">
                        <i  class="ri-add-circle-line align-bottom me-1"></i> Add Task
                    </a>
                </div>
            </div>
        </div>-->
        <div class="row newcountbox" v-if="taskCount">
            <div class="col">
                <div class="card bg-soft-secondary">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-secondary">{{taskCount.confirmOrder}}</h1>
                        <div class="fw-medium">Confirm order</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-dark">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-dark">{{taskCount.artworkApproval}}</h1>
                        <div class="fw-medium">Artwork approval</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-success">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-success">{{taskCount.payDeposit}}</h1>
                        <div class="fw-medium">Pay deposit</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-primary">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-primary">{{taskCount.sampleApproval}}</h1>
                        <div class="fw-medium">Sample for Approval</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-danger">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-danger">{{taskCount.awaitReadyDate}}</h1>
                        <div class="fw-medium">Awaiting ready date</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-warning">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-warning">{{taskCount.scheduleShipping}}</h1>
                        <div class="fw-medium">Schedule shipping</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="new-rfq">
            <fieldset class="customer-search mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-auto">
                                <form class="form-inline list-search" action="">
                                    <div class="filter-sec">
                                        <button type="button" class="btn filter-btn" @click="toggleShowFilters">
                                            <i class="ri-filter-line align-bottom me-1"></i> Filters
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div class="col-lg-3 col-auto">
                                <form class="form-inline list-search" @submit.prevent="search(1)">

                                    <div class="input-group">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" @click.prevent="search"><i class="ri-search-line search-icon"></i></button>
                                        </div>
                                        <input v-model="filterForm.search_filter" type="text" class="form-control"
                                               placeholder="Quick Search">

                                    </div>

                                </form>
                            </div>
                            <div class="col-auto ms-sm-auto">
                                <div class="btnrow float-right">
                                    <div class="d-flex align-items-center">
                                        <a href="javascript:void(0)" v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('add-task')" data-toggle="modal" data-target="#addTaskModal" class="btn create-btn">
                                            <i  class="ri-add-circle-line align-bottom me-1"></i> Add Task
                                        </a>
                                        <div class="quotes-text">{{ total }} Tasks</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="filter-row" v-if="showFilters">
                            <div class="form-group">
                                <select class="form-control" v-model="filterForm.status" @change="search(2)">
                                    <option :value="null">Status</option>
                                    <option value="0">Open</option>
                                    <option value="1">Completed</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <select class="form-control" v-model="filterForm.order_type" @change="search(2)">
                                    <option :value="null">Type</option>
                                    <option value="so">Sales Order</option>
                                    <option value="po">Purchase Order</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <v-select label="text" :filterable="false"
                                          v-model="filterForm.order"
                                          :options="orders"
                                          @search="onOrderSearch"
                                          @input="onOrderSelect"
                                          @selected="onOrderSelect"
                                          @deselected ="onOrderDeSelect">
                                    <template slot="no-options">
                                        type to search orders..
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center" v-html="option.text">
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center" v-html="option.text">
                                        </div>
                                    </template>
                                </v-select>
                            </div>

                            <div class="form-group">
                                <select class="form-control" v-model="filterForm.search_assigns" @change="search(2)">
                                    <option :value="null">Assigned To</option>
                                    <option v-for="(admin_user, index) in filters.admin_users" :value="admin_user.id">
                                        {{ admin_user.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="search-btnsec dl-flex">
                                <button class="btn btn-success" type="button" @click.prevent="search(2)"><i class="ri-search-line search-icon"></i>
                                </button>
                                <button class="btn btn-reset" type="button" @click="resetFilter"><i class="ri-refresh-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>


            <div class="row">

                <div class="col-lg-12 col-md-12">
                    <div class="card panel ">
                        <!--<div class="card-header headnbtn">
                            <div  class="d-flex align-items-center justify-content-between">
                                <h5  class="card-title mb-0 flex-grow-1">Order Tasks</h5>
                            </div>
                        </div>-->
                        <div class="card-body p-0" v-if="taskData.tasks">
                            <div class="table-responsive product-create mb-0">
                                <table class="table table-custom table-nowrap table-bordered align-middle mb-0">
                                    <thead>
                                    <tr>
                                        <th>Order Number</th>
                                        <th>Task Name</th>
                                        <th>Assigned to</th>
                                        <th>Due Date</th>
                                        <th>Priority</th>
                                        <th style="width: 180px">Action </th>
                                    </tr>
                                    </thead>
                                    <tr v-for="(task, index) in taskData.tasks.data" :key="task.id" :id="task.id">
                                        <td>
                                            <template
                                                v-if="task.taskable_type === 'App\\Models\\Order' && task.taskable">
                                                <router-link
                                                    :to="{ name: 'orderShow', params: { id: task.taskable.id }}"
                                                    href="javascript:void(0)">#{{ task.taskable.order_number }}
                                                </router-link>
                                            </template>
                                            <template
                                                v-if="task.taskable_type === 'App\\Models\\PurchaseOrder' && task.taskable">
                                                <router-link
                                                    :to="{ name: 'purchaseOrderShow', params: { id: task.taskable.id }}"
                                                    href="javascript:void(0)">#{{ task.taskable.po_number }}
                                                </router-link>
                                            </template>
                                        </td>
                                        <td class="t-sts">
                                            <template v-if="task.status == 1 || task.status == '1'">
                                                <i class="fa fa-check-circle" style="color: green;" ></i>
                                            </template>
                                            <template v-else> <i class="fa fa-check-circle"></i></template>

                                            <template v-if="task.status === 0 && enableAction">
                                                <template v-if="task.title === 'Create PO'">
                                                    <template v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('add-purchase-order')">
                                                        <a href="javascript:void(0);" @click="createPO(task)">{{task.title}}</a>
                                                    </template>
                                                    <template v-else> {{task.title}}</template>
                                                </template>
                                                <template v-else> {{task.title}}</template>
                                            </template>
                                            <template v-else>
                                                {{ task.title }}
                                            </template>
                                        </td>
                                        <td>
                                            <template v-for="(admin, adminIndex) in task.admins">
                                                <template v-if="adminIndex > 0">, </template>{{admin.name}}
                                            </template>
                                        </td>

                                        <td>
                                            <template v-if="task.status == 1 || task.status == '1'">
                                                Completed at {{formatDate(task.completed_at)}}
                                            </template>
                                            <template v-else>
                                                {{formatDate(task.due_date)}} <span class="text-danger">{{getTimeAgo(task.due_date)}}</span>
                                            </template>
                                        </td>
                                        <td><span class="badge" :class="nameToCSSClass(task.priority.priority_name, 'badge-soft-')" v-if="task.priority">{{task.priority.priority_name}}</span></td>
                                        <td>
                                            <a v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin')" href="javascript:void(0)" @click="editTask(task)" class="edit_btn" title="Edit Task"><i class="ri-edit-fill me-1"></i></a>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </div>

                        <div class="btnrow text-left mb-3">
                            <template v-if="taskData.tasks != null && taskData.tasks.data.length">
                                <div class="overflow-auto">
                                    <b-pagination
                                        v-model="current_page"
                                        :total-rows="total"
                                        :per-page="per_page"
                                    ></b-pagination>
                                </div>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="6" style="padding: 0.75rem 0.85rem;">No records found!</td>
                                </tr>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <AddTask :task="task" @addedEvent="taskAddedEvent" @updatedEvent="taskUpdatedEvent"></AddTask>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import AddTask from "../../components/AddTask";
import moment from "moment";
import axios from "axios";
import {debounce} from "lodash";

export default {
    name: "Tasks",
    components: {AddTask},
    created() {

    },
    mounted() {
        this.getFilters();
        this.getTasks();
        let self = this;
        $('#addTaskModal').on('hidden.bs.modal', function () {
            self.task = null;
        });
    },
    data(){
        return {
            taskCount: {
                confirmOrder: 0,
                artworkApproval: 0,
                payDeposit: 0,
                sampleApproval: 0,
                awaitReadyDate: 0,
                scheduleShipping: 0,
            },
            enableAction: false,
            task: null,
            current_page:1,
            per_page:5,
            total:0,
            filterForm: {
                search_filter: null,
                search_assigns: null,
                order_type: 'so',
                order_id: null,
                order: null,
                search_by_date: null,
                status: null,
                date_range: null
            },
            taskData: {
                tasks: null,
                can_add_task: false,
                can_edit_task: false,
                can_delete_task: false,
                role: null,
                admin: null
            },
            showFilters: false,
            filters: {
                statuses: [],
                sale_users: [],
                admin_users: [],
            },
            orders: [],
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setCustomerLoading',
            'setTaskFilterData',
            'setTaskShowFilters',
            'setNewPurchaseOrder'
        ]),
        createPO(task) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.show', {id: task.taskable_id}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        let admin_users = _.cloneDeep(data.admin_users);
                        data.data.new_admin_users = [];
                        if(data.data.admin_users) {
                            data.data.admin_users.forEach((x) => {
                                data.data.new_admin_users.push(x.admin);
                            });
                        }
                        if (data.data.artworks && data.data.artworks.length > 0 && data.data.latest_artwork == null) {
                            data.data.latest_artwork = _.cloneDeep(data.data.artworks[data.data.artworks.length - 1]);
                        }
                        data.data.products.forEach((x) => {
                            if (x.artworks && x.artworks.length > 0 && x.latest_artwork == null) {
                                x.latest_artwork = _.cloneDeep(x.artworks[x.artworks.length - 1]);
                            }
                        });
                        if(data.data.customer && data.data.customer.customer_contacts && data.data.customer.customer_contacts.length > 1) {
                            data.data.customer.customer_contacts = data.data.customer.customer_contacts.filter((x) => x.deleted === 0);
                        }

                        if(data.customer && data.customer.customer_contacts && data.customer.customer_contacts.length > 1) {
                            data.customer.customer_contacts = data.customer.customer_contacts.filter((x) => x.deleted === 0);
                        }

                        let order = data.data;

                        order.admin_users = [];
                        order.order_admins.forEach((admin) => {
                            order.admin_users = admin_users.filter((x) => admin.admin_id == x.id);
                        });

                        if(order.original_customer_file && order.customer_file_media_id &&  order.artworks.length == 0) {
                            order.artworks.push({
                                id: null,
                                is_approve: 0,
                                attach_link: null,
                                comment: null,
                                updated_at: null,
                                media_id: null,
                                artwork_status_id: 1,
                                customer_file_media_id: this.order.customer_file_media_id
                            });
                        }

                        if (order.products) {
                            order.products.forEach((x) => {
                                if(x.original_customer_file && x.uploaded_media_id &&  x.artworks.length == 0) {
                                    x.artworks.push({
                                        id: null,
                                        is_approve: 0,
                                        attach_link: null,
                                        comment: null,
                                        updated_at: null,
                                        media_id: null,
                                        artwork_status_id: 1,
                                        customer_file_media_id: x.uploaded_media_id
                                    });
                                }
                            });
                        }

                        return axios.get(window.route('orders.quotations.index', {id: task.taskable_id}), {

                            validateStatus: function (status) {
                                return status < 500; // Resolve only if the status code is less than 500
                            }
                        })
                            .then(({data}) => {
                                if (data.errors && data.errors.length) {
                                    self.setCommonErrors(data.errors);
                                } else if (data.errorMessage) {
                                    self.setErrorMessage(data.errorMessage);
                                } else {
                                    let orderQuotes = data.data;
                                    this.createPOFromSO(order, orderQuotes, this.setNewPurchaseOrder)
                                }
                            })
                            .catch((error) => {
                                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                            })
                            .finally(() => {
                                self.setLoading(false);

                            });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });

        },
        resetFilter() {
            this.filterForm = {
                search_filter: null,
                search_assigns: null,
                order_type: 'so',
                order_id: null,
                order: null,
                search_by_date: null,
                status: null,
                date_range: null
            };

            this.setTaskFilterData(this.filterForm);
            this.search();
        },
        toggleShowFilters(){
            this.showFilters = !this.showFilters;
            this.setTaskFilterData(this.showFilters);
        },
        search(buttonIndex) {
            if(buttonIndex === 1) {
                this.getTasks();
            } else {
                this.getTasks();
            }
        },
        onOrderSelect(event){
            if (event) {
                this.filterForm.order_id = event.id;
            } else {
                this.filterForm.order_id = null;
            }

            this.search();
        },
        onOrderDeSelect(event){
            this.filterForm.order_id = null;
            this.search();
        },
        onOrderSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchOrder(loading, search, this);
            }
        },
        searchOrder: debounce((loading, search, vm) => {
            let url = window.route('orders.search', {searchTerm: search});
            if(vm.filterForm.order_type == 'po') {
                url = window.route('po.search', {searchTerm: search});
            }
            return axios.get(url,  {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.orders = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
        getTimeAgo(datetime) {
            return moment(datetime).fromNow();
        },
        editTask(task) {
            this.task = _.cloneDeep(task);
            setTimeout(() => {
                $('#addTaskModal').modal('show');
            }, 100);
        },
        taskAddedEvent(event){
            this.getTasks();
            $('#addTaskModal').modal('hide');
        },
        taskUpdatedEvent(event){
            this.task = null;
            this.getTasks();
            $('#addTaskModal').modal('hide');
        },
        getTasks() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('dashboard.tasks.index', {
                search_filter: this.filterForm.search_filter,
                search_assigns: this.filterForm.search_assigns,
                status: this.filterForm.status,
                order_type: this.filterForm.order_type,
                order_id: this.filterForm.order_id,
                search_by_date: this.filterForm.search_by_date,
                date_range: this.filterForm.date_range,
                page: this.current_page,
            }), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.taskData.tasks = data.data;

                        //this.current_page = data.data.current_page;
                        this.per_page = data.data.per_page;
                        this.total = data.data.total;

                        this.taskData.admin = data.extra.admin;
                        this.taskData.role = data.extra.role;
                        this.taskData.can_add_task = data.extra.can_add_task;
                        this.taskData.can_delete_task = data.extra.can_delete_task;
                        this.taskData.can_edit_task = data.extra.can_edit_task;
                        this.taskCount = data.extra.taskCount;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteTask() {
            if(this.deleteId) {
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('dashboard.tasks.destroy', {id: this.deleteId}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            self.getTasks();
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            }
        },
        getFilters() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.getFilters'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors && data.errors.length) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.filters = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading'
        ])
    },
    watch: {
        current_page: {
            handler: function (value) {
                this.getTasks();
            }
        },
        'filterForm.order_type': {
            handler: function (value) {
                this.orders = [];
                this.filterForm.order_id = null;
                this.filterForm.order = null;
                this.getTasks();
            }
        },
    }
}
</script>

<style scoped>

</style>
